(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ibs-bastion-flash-promo"] && !Shopify.designMode) return;
  try {
    const ibsBastionFlashEndsAt = Date.parse('2026-09-05T22:00:00Z');
  const removeIbsBastionFlash = () => {
    document.querySelectorAll('[data-ibs-bastion-flash]').forEach((element) => element.remove());
  };
  const ibsBastionFlashRemaining = ibsBastionFlashEndsAt - Date.now();

  if (ibsBastionFlashRemaining <= 0) {
    removeIbsBastionFlash();
  } else {
    window.setTimeout(removeIbsBastionFlash, ibsBastionFlashRemaining + 250);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ibs-bastion-home-flash"] && !Shopify.designMode) return;
  try {
    (() => {
    const mountBastionHomeFlash = () => {
      const promo = document.querySelector('[data-ibs-bastion-home-flash]');
      if (!promo) return;

      const endsAt = Date.parse('2026-09-05T22:00:00Z');
      if (Date.now() >= endsAt) {
        promo.remove();
        return;
      }

      const main = document.getElementById('MainContent');
      if (main && main.firstElementChild !== promo) {
        main.insertBefore(promo, main.firstElementChild);
      }

      promo.hidden = false;

      window.setTimeout(() => {
        if (promo.isConnected) promo.remove();
      }, Math.max(0, endsAt - Date.now()) + 250);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', mountBastionHomeFlash, { once: true });
    } else {
      mountBastionHomeFlash();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ibs-bastion-promo-price"] && !Shopify.designMode) return;
  try {
    const ibsBastionPromoPriceEndsAt = Date.parse('2026-09-05T22:00:00Z');
  const removeIbsBastionPromoPrices = () => {
    document.querySelectorAll('[data-ibs-bastion-promo-price]').forEach((element) => element.remove());
  };
  const ibsBastionPromoPriceRemaining = ibsBastionPromoPriceEndsAt - Date.now();

  if (ibsBastionPromoPriceRemaining <= 0) {
    removeIbsBastionPromoPrices();
  } else {
    window.setTimeout(removeIbsBastionPromoPrices, ibsBastionPromoPriceRemaining + 250);
  }
  } catch(e) { console.error(e); }
})();

})();
